export const ScrollbarStyles = () => (
  <style>{`
    .product-modal-extended-scroll-column {
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .product-modal-extended-scroll-column::-webkit-scrollbar {
      display: none;
    }
  `}</style>
)
